module.exports = __webpack_public_path__ + "img/2600m.a50b99fc.png";